import { DatePicker as AntdDatePicker } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const DatePickerDropdownStyles = createGlobalStyle`
  /* Presets section */
  .my-range-picker-dropdown .ant-picker-presets {
    padding: 24px 16px;
    border-inline-end: 1px solid ${(props) => props.theme.semantic.divider};
  }

  .ant-picker-presets ul {
    padding: 0 !important;
    border-inline-end: none !important;
  }

  .ant-picker-presets ul li + li {
    margin-top: 16px !important;
  }

  .ant-picker-presets ul li {
    padding-inline: 0 !important;
  }

  .ant-picker-presets ul li:hover {
    background-color: transparent !important;
    color: ${(props) => props.theme.semantic.primary} !important;
  }

  /* Header */
  .ant-picker-dropdown .ant-picker-header {
    margin: 16px 12px 0px 12px;
    border-radius: 8px;
    height: 35px;
    border: 1px solid ${(props) => props.theme.semantic.divider};
  }

  .ant-picker-dropdown .ant-picker-header .ant-picker-header-view button {
    text-align: center;
    height: 100%;
  }

  .ant-picker-dropdown .ant-picker-header-view > button {
    color: ${(props) => props.theme.semantic.primary};
  }

  /* Cells */
  .ant-picker-dropdown .ant-picker-content td {
    min-width: 40px;
  }

  .ant-picker-dropdown .ant-picker-cell::before {
    height: 40px;
  }

  .ant-picker-dropdown .ant-picker-cell .ant-picker-cell-inner {
    min-width: 40px;
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    color: ${(props) => props.theme.semantic.textPrimary};
  }

  /*today*/
  .ant-picker-cell-today .ant-picker-cell-inner{
      color: ${(props) => props.theme.semantic.primary} !important;
  }
      
  /* Cells outside month (disabled) */
  .my-range-picker-dropdown
    td.ant-picker-cell:not(.ant-picker-cell-in-view) {
    pointer-events: none !important;
    opacity: 0.5 !important;
    cursor: not-allowed !important;
  }

  .my-range-picker-dropdown
    td.ant-picker-cell:not(.ant-picker-cell-in-view) .ant-picker-cell-inner {
    background: transparent !important;
    color: ${(props) => props.theme.semantic.neutral} !important;
    border-radius: 0 !important;
  }

  .my-range-picker-dropdown
    td.ant-picker-cell:not(.ant-picker-cell-in-view)::before {
    background: transparent !important;
  }

  .my-range-picker-dropdown
    td.ant-picker-cell:not(.ant-picker-cell-in-view).ant-picker-cell-in-range,
  .my-range-picker-dropdown
    td.ant-picker-cell:not(.ant-picker-cell-in-view).ant-picker-cell-range-start,
  .my-range-picker-dropdown
    td.ant-picker-cell:not(.ant-picker-cell-in-view).ant-picker-cell-range-end {
    background: transparent !important;
  }

  /* Range selection for in-view cells */
  .my-range-picker-dropdown
    td.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range::before {
    height: 40px !important;
    background-color: ${(props) => props.theme.semantic.primaryLight} !important;
    border-radius: 0 !important;
  }

  .my-range-picker-dropdown
    td.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range
    .ant-picker-cell-inner {
    color: ${(props) => props.theme.semantic.textPrimary} !important;
    border-radius: 0 !important;
  }

  /* Range start */
  .my-range-picker-dropdown
    td.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start
    .ant-picker-cell-inner {
    border-radius: 20px 0 0 20px !important;
    background: ${(props) => props.theme.semantic.primary} !important;
    color: ${(props) => props.theme.semantic.onPrimary} !important;
  }

  .my-range-picker-dropdown
    td.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start::before {
    display: none !important;
  }

  /* Range end */
  .my-range-picker-dropdown
    td.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-end
    .ant-picker-cell-inner {
    border-radius: 0 20px 20px 0 !important;
    background: ${(props) => props.theme.semantic.primary} !important;
    color: ${(props) => props.theme.semantic.onPrimary} !important;
  }

  /* Single month view */
  .dateRangePicker .ant-picker-panel:nth-child(2) {
    display: none;
  }

  .dateRangePicker .ant-picker-panel:nth-child(1) button {
    visibility: visible !important;
  }

  /* Single-day range: when start and end are the same date */
.my-range-picker-dropdown
  td.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-end
  .ant-picker-cell-inner {
  background: ${(props) => props.theme.semantic.primary} !important;
  color: ${(props) => props.theme.semantic.onPrimary} !important;
  border-radius: 20px !important;
}

.my-range-picker-dropdown
  td.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-end::before {
  display: none !important; 
}
`;

export const StyledDatePicker = styled(AntdDatePicker.RangePicker)``;
